import React from 'react'

import './default.scss'

const DefaultLayout = ({ header, sidebar, children, footer }) => (
	<div className="o-page">
		{header}
		{sidebar}
		<main className="o-page__content">{children}</main>
		{footer}
	</div>
)

export default DefaultLayout
